import React from 'react';
import { useSelector } from 'react-redux';

import LopAndOvertimeRequestTable from './components/LopAndOvertimeRequestTable';
import LopAndOvertimeRequestTools from './components/LopAndOvertimeRequestTools';
import LopAndOvertimeRequestFormModel from './components/LopAndOvertimeRequestFormModel';

const LopAndOvertimeRequestList = () => {
  const lopOvertimeState = useSelector((state) => state.lopOvertimeRequest);

  return (
    <div className="container-xxl">
      <LopAndOvertimeRequestTools />

      {lopOvertimeState?.isModal?.model && <LopAndOvertimeRequestFormModel />}
      <LopAndOvertimeRequestTable />
    </div>
  );
};

export default LopAndOvertimeRequestList;
